import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../data/persons/actions';
import * as os from 'osutil';

class AvatarList extends Component {
  state = { };

  componentWillMount() {
    this.props.fetchPersons();//(this.props.params.id);
  }

  renderPersons() {
    return _.map(this.props.persons, (seg, key) => {
      return <div key={key}  className="avatarlist__person">
      <div>
        <span className="avatarlist__person__name">{seg.name}</span>
        <span className="avatarlist__person__description">{seg.description}</span>
      </div>
      { seg.avatarUrl && 
        <img alt="Avatar" src={seg.avatarUrl}  />
      }
      </div>
    });
  }

  render() {

    return (
      <span className="avatarlist">
      {this.renderPersons()}
      </span>
    );
  }
}

function mapStateToProps(state, ownProps) {

  if (!state || !state.persons.list.data || !ownProps.persons)
  {
    return {};
  }
  return {
    persons: os.collection_by_keys(state.persons.list.data, Object.keys(ownProps.persons))
  };
}

export default connect(mapStateToProps, actions)(AvatarList)

  



// WEBPACK FOOTER //
// ./src/components/Lists/AvatarList.jsx